import moment from "moment";
class attributs {
  constructor(
    anomalies,
    aus,
    advertisement,
    day,
    empId,
    ext,
    extras,
    date,
    endDay,
    hca,
    inc,
    startDay,
    lab,
    file,
    liD,
    liH,
    movimId,
    company,
    group,
    normals,
    ret,
    tar,
    trab,
    firm,
    nameSchedule,
    horLab,
    noveltyEarring,
    segmId,
    order
  ) {
    function hours(param) {
      let horas = Math.floor(param / 60);
      let min = Math.floor(horas * 60);
      min = param - min;
      if (horas < 10) {
        horas = "0" + horas;
      }
      min = min < 10 ? "0" + min : min;
      return horas + ":" + min;
    }

    this.anomalies = anomalies ? "🔴" : " ";
    this.aus = aus;
    this.advertisement = advertisement ? "🟡" : " ";
    this.day = day.slice(0, 3);
    this.empId = empId;
    this.ext = ext;
    this.extras = extras ? "🟢" : " ";
    this.date = moment(date).utc().format("DD-MM-YYYY");
    this.endDay = moment(endDay).utc().format("YYYY-MM-DD HH:mm");
    this.hca = hca;
    this.inc = inc;
    this.startDay = moment(startDay).utc().format("YYYY-MM-DD HH:mm");
    this.lab = hours(lab);
    this.file = file;
    this.liD = liD;
    this.liH = liH;
    this.movimId = movimId;
    this.company = company;
    this.group = group;
    this.normals = normals ? "🔵" : " ";
    this.ret = ret;
    this.tar = tar;
    this.trab = hours(trab);
    this.firm = firm;
    this.nameSchedule = nameSchedule;
    this.horLab = horLab;
    this.noveltyEarring = noveltyEarring;
    this.dateNotFormat = date;
    this.idController = empId.toString() + date;
    this.segmId = segmId;
    this.order = order;
  }
  static fromJson({
    anomalias,
    aus,
    avisos,
    dia,
    empId,
    ext,
    extras,
    fecha,
    finDia,
    hca,
    inc,
    inicioDia,
    lab,
    legajo,
    liD,
    liH,
    movimId,
    nomEmp,
    nomGrp,
    normales,
    ret,
    tar,
    trab,
    ultimaFirma,
    nomHorario,
    horlab,
    novedPend,
    segmId,
    orden,
  }) {
    return new attributs(
      anomalias,
      aus,
      avisos,
      dia,
      empId,
      ext,
      extras,
      fecha,
      finDia,
      hca,
      inc,
      inicioDia,
      lab,
      legajo,
      liD,
      liH,
      movimId,
      nomEmp,
      nomGrp,
      normales,
      ret,
      tar,
      trab,
      ultimaFirma,
      nomHorario,
      horlab,
      novedPend,
      segmId,
      orden
    );
  }
}
export default attributs;
